@if (agrupamento?.pedidos?.length > 0) {
    <div class="visao-geral-pedido">
        <app-header
            [brandIconName]="agrupamento?.marca"
            [title]="agrupamento?.veiculo"
            [subtitle]="!settingService.isMercadoPartsfy(agrupamento?.veiculo) ? ('buyer.dados-pedido.itens.cabecalho.chassi' | translate) + agrupamento.chassi_formatado : null"
            (onGoBack)="voltar($event)"
        ></app-header>

        <div class="col-md-12 card card-default painelcomprador area-pedido {{ accountService.getCssInIframe() }}">
            <ng-scrollbar>
                <app-dados-pedido [agrupamento]="agrupamento" [deliveryTimes]="deliveryTimes" [feriados]="feriados" [formasPagamento]="formasPagamento"
                    [transportadoras]="transportadoras" [voltarHome]="true"
                    (atualizarPedido)="atualizarPedido($event)"
                    (copyGetConfirmation)="copyGetConfirmation($event)"></app-dados-pedido>
            </ng-scrollbar>
        </div>
    </div>
}
<ngx-ui-loader [loaderId]="'loader-principal'"></ngx-ui-loader>
